// extracted by mini-css-extract-plugin
export default {"main":"AITeacherResponse_main__0+p3G","header":"AITeacherResponse_header__-+CaF"};